export default [
  { id: 1, name: 'Головная компания', regionId: 1 },
  { id: 2, name: 'Большевик', regionId: 1 },
  { id: 3, name: 'Округ', regionId: 1 },
  { id: 4, name: 'Филиал', regionId: 1 },
  { id: 5, name: 'Объект логистики', regionId: 1 },
  { id: 6, name: 'Объект СП', regionId: 1 },
  { id: 7, name: 'ММ', regionId: 2 },
  { id: 8, name: 'МК', regionId: 2 },
  { id: 9, name: 'БФ', regionId: 2 },
  { id: 10, name: 'ХД (В1)', regionId: 2 },
  { id: 11, name: 'Омни (Магнит Маркет, Магнит Доставка)', regionId: 2 },
];
